export const CHAT_FULL_ACCESS = 'CHAT_FULL_ACCESS';
export const BROADCAST_FULL_ACCESS = 'BROADCAST_FULL_ACCESS';
export const SHOWS_FULL_ACCESS = 'SHOWS_FULL_ACCESS';
export const SCHEDULES_FULL_ACCESS = 'SCHEDULES_FULL_ACCESS';
export const LISTS_FULL_ACCESS = 'LISTS_FULL_ACCESS';
export const DOCS_FULL_ACCESS = 'DOCS_FULL_ACCESS';
export const FULL_SCREEN_FEATURED_VIEW_FULL_ACCESS =
  'FULL_SCREEN_FEATURED_VIEW_FULL_ACCESS';

export const permissionMapper = {
  BROADCAST_FULL_ACCESS: 'broadcast',
  SHOWS_FULL_ACCESS: 'show',
  SCHEDULES_FULL_ACCESS: 'schedule',
  LISTS_FULL_ACCESS: 'list',
  DOCS_FULL_ACCESS: 'eventDoc',
  FULL_SCREEN_FEATURED_VIEW_FULL_ACCESS: 'teleprompter'
};

export const TypePermissionLookup = {
  rundown: SHOWS_FULL_ACCESS, // rundown is mapped to the same permission as show
  show: SHOWS_FULL_ACCESS,
  schedule: SCHEDULES_FULL_ACCESS,
  list: LISTS_FULL_ACCESS,
  eventDoc: DOCS_FULL_ACCESS,
  broadcast: BROADCAST_FULL_ACCESS,
  interactiveStream: BROADCAST_FULL_ACCESS,
  teleprompter: FULL_SCREEN_FEATURED_VIEW_FULL_ACCESS
};

const enabled = 'enabled';
const pretrial = 'pretrial';
const trial = 'trial';
const disabled = 'disabled';

export const PermissionStatuses = {
  enabled,
  disabled,
  trial,
  pretrial,
  all: [enabled, disabled, trial, pretrial]
};

export const StripeProductPermissions = [
  BROADCAST_FULL_ACCESS,
  SHOWS_FULL_ACCESS
];
